var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophicDecomposers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.394 8.677h-3.91c0 1.357-.559 2.395-.559 3.153 0 1.197.798 2.633 2.554 2.633 1.755 0 2.474-1.556 2.474-2.633 0-.679-.559-1.756-.559-3.153Z",
    fill: "#303752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.18 7.48H1.82a.568.568 0 0 1-.581-.605C1.44 4.445 2.864.537 7.499.537c4.636 0 6.07 3.912 6.261 6.341a.567.567 0 0 1-.58.602ZM6.64 4.206a.638.638 0 1 1-1.277 0 .638.638 0 0 1 1.277 0Zm-3.035 1.92a.638.638 0 1 0 0-1.277.638.638 0 0 0 0 1.277Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophicDecomposers);
export default __webpack_public_path__ + "static/media/trophic-decomposers.0102523506a7c90abd5336520fae4a20.svg";
export { ForwardRef as ReactComponent };